import { useRef, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Signature } from "@phosphor-icons/react";
import { MobileScanQR } from "./MobileScanQR";
import { MailboxScanPicker } from "./MailboxScanPicker";

export const SCAN_ACCEPT = "application/pdf,image/*";

export function buildScanForm(files) {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append("files", f));
  return fd;
}

// Nachgereichter Scan: ersetzt das gespeicherte Schreiben und erledigt die Aufgabe.
export function SignedScanUploadButton({ documentId, onDone, size = "sm", testId = "signed-scan-upload-btn" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/messages/documents/${documentId}/signed-scan`, buildScanForm(files), {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(`Unterschriebenes Exemplar gespeichert (${data.pages} Seite${data.pages === 1 ? "" : "n"})`);
      onDone?.(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Scan konnte nicht gespeichert werden");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" multiple accept={SCAN_ACCEPT} className="hidden"
             onChange={(e) => upload(e.target.files)} data-testid={`${testId}-input`} />
      <Button size={size} variant="outline" disabled={busy} onClick={() => inputRef.current?.click()}
              className="gap-1.5 border-indigo-300 text-indigo-800 hover:bg-indigo-50" data-testid={testId}>
        <Signature size={14} /> {busy ? "Lädt hoch…" : "Unterschriebenen Scan einfügen"}
      </Button>
      <MobileScanQR documentId={documentId} size={size} testId={`${testId}-mobile`}
                    onReceived={(d) => onDone?.(d)} />
      <MailboxScanPicker size={size} endpoint={(mid) => `/messages/documents/${documentId}/signed-scan/from-mailbox/${mid}`}
                         onPicked={(d) => onDone?.(d)} testId={`${testId}-mailbox`} />
    </>
  );
}
